import React from 'react';
import { string, object, bool } from 'prop-types';
import { Box, Heading, Text, Button } from '@chakra-ui/react';
import { DEFAULT_BUTTON_PROPS } from '@/constants/colors';

import txtWording from './locales';
import useLang from '@/hooks/useLang';
import useInvitation from '@/hooks/useInvitation';
import AddToCalendarButton from '@/components/Common/AddToCalendar';
import AddToCalendarButtonPemberkatan from '@/components/Common/AddToCalendar/calendarPemberkatan';
import { TEXT_PROPS } from '@/constants/default-props';

function WeddingDetail({
  title,
  titleProps,
  subTitlePlace,
  subTitlePlaceDetail,
  date,
  time,
  dresscode,
  gmaps,
  calendar,
  calendarPemberkatan,
  note,
}) {
  const lang = useLang();
  const handleClickGoogleMaps = () => {
    window.open(gmaps, '_blank');
  };
  const isInvitation = useInvitation();

  return (
    <Box color="mainColorTextLighter">
      <Heading
        {...TEXT_PROPS.heading}
        paddingLeft="0px"
        textAlign="left"
        margin="12px 0"
        {...titleProps}
        color="mainColorText"
      >
        {title}
      </Heading>

      <Text {...TEXT_PROPS.body} textAlign="left" fontStyle="none" mb="2px" color="mainColorText">
        {date}
      </Text>
      <Text {...TEXT_PROPS.body} textAlign="left" fontStyle="none" mb="2px" color="mainColorText">
        {time}
      </Text>
      <Text
        {...TEXT_PROPS.body}
        textAlign="left"
        fontStyle="none"
        mb="2px"
        color="mainColorText"
        marginTop="6px"
      >
        {subTitlePlace}
      </Text>
      <Text {...TEXT_PROPS.body} textAlign="left" fontStyle="none" mb="2px" color="mainColorText">
        {subTitlePlaceDetail}
      </Text>
      {dresscode && (
        <Text
          {...TEXT_PROPS.body}
          textAlign="left"
          fontStyle="none"
        >{`Dresscode: ${dresscode}`}</Text>
      )}
      {note && <Text {...TEXT_PROPS.body} textAlign="left" fontStyle="italic">{`*) ${note}`}</Text>}
      {gmaps && isInvitation && (
        <Button
          onClick={handleClickGoogleMaps}
          {...DEFAULT_BUTTON_PROPS}
          fontSize="lg"
          padding="0 12px"
          margin="16px 0 0 0px"
          bgColor="bgSecondary"
          color="secondaryColorText"
          _hover={{ opacity: 0.6 }}
        >
          {txtWording.location[lang]}
        </Button>
      )}
      {calendar && (
        <AddToCalendarButton
          text={txtWording.calendar[lang]}
          {...DEFAULT_BUTTON_PROPS}
          fontSize="lg"
          padding="0 12px"
          margin="16px 0 0 16px"
          bgColor="bgAlternative"
          color="alternativeColorText"
          _hover={{ opacity: 0.8 }}
        />
      )}
      {calendarPemberkatan && (
        <AddToCalendarButtonPemberkatan
          text={txtWording.calendar[lang]}
          {...DEFAULT_BUTTON_PROPS}
          fontSize="lg"
          padding="0 12px"
          margin="16px 0 0 16px"
          bgColor="bgAlternative"
          color="alternativeColorText"
          _hover={{ opacity: 0.8 }}
        />
      )}
    </Box>
  );
}

WeddingDetail.propTypes = {
  date: string.isRequired,
  dresscode: string,
  note: string,
  subTitlePlace: string,
  subTitlePlaceDetail: string,
  time: string.isRequired,
  title: string.isRequired,
  titleProps: object,
  gmaps: string,
  calendar: bool,
  calendarPemberkatan: bool,
};

WeddingDetail.defaultProps = {
  dresscode: '',
  gmaps: '',
  note: '',
  titleProps: {},
  calendar: false,
  calendarPemberkatan: false,
};

export default React.memo(WeddingDetail);
